import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"

import ModalService from "src/modals"
import apiClient from "src/apiClient"
import { getGames } from "src/store/game"
import { gameModeName } from "src/utils/gameModes"

import Modal from "src/components/modals/Modal"
import "./GameHistoryModal.css"

/**
 * Every game in progress, for staff to watch (owner, 2026-10-04: *"Staff users can join open games
 * as spectators"*). A row seats the account as a spectator (`POST /game/{id}/spectate/`, staff
 * only — the server is the gate) and walks into the game, where the spectator's banner and its
 * Leave button already are. The rows are the history shelf's, so the two lists read alike.
 */
const WatchGamesModal = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [games, setGames] = useState(null)
  useEffect(() => {
    let cancelled = false
    apiClient
      .get("/game/open/")
      .then((response) => !cancelled && setGames(response.data || []))
      .catch(() => !cancelled && setGames([]))
    return () => {
      cancelled = true
    }
  }, [])

  const watch = async (game) => {
    await apiClient.post(`/game/${game.id}/spectate/`)
    // The game joins the account's shelf only through the bootstrap list, which the route's guard
    // picks the viewed game from.
    await dispatch(getGames())
    ModalService.hideAll()
    navigate(`/game/${game.id}`)
  }

  const sides = (game) =>
    ["human", "zombie"]
      .map((team) =>
        game.players
          .filter((player) => player.team === team)
          .map((player) => player.username)
          .join(", ")
      )
      .filter(Boolean)
      .join(" vs ")

  return (
    <Modal width="640px">
      <h1>{t("home.watchGames")}</h1>

      {games === null && <p className="history-note">{t("home.historyLoading")}</p>}
      {games !== null && games.length === 0 && <p className="history-note">{t("home.watchGamesEmpty")}</p>}

      {games !== null && games.length > 0 && (
        <div className="history-rows">
          {games.map((game) => (
            <button type="button" key={game.id} className="history-row" onClick={() => watch(game)}>
              <span className="history-result">#{game.id}</span>
              <span className="history-opponents">{sides(game) || "—"}</span>
              <span className="history-meta">
                {t("home.watchGamesMeta", { mode: gameModeName(game.mode), rounds: game.rounds })}
              </span>
              <span className="history-watch">{game.in_game ? t("home.liveGameOpen") : t("home.historyWatch")}</span>
            </button>
          ))}
        </div>
      )}
    </Modal>
  )
}

export default WatchGamesModal
